import React, { Component } from 'react';

import PropTypes from 'prop-types';

// COMPONENT
import Loader from '../Loader/Loader'

// HELPERS
import { capitalize } from '../../util/util';

import styles from './SmallCarousel.module.scss';

class WatchListCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.carousel = React.createRef();
  }

  returnCarouselLength = (cards) => window.innerWidth * (cards.length / 2.3); // eslint-disable-line

  renderDetails = (header, subHeader) => (
    <div className={styles.cardDetails}>
      <h3>{header}</h3>
      <div>
        {subHeader ? (
          <>
            <p className={subHeader < 0 ? styles.neg : styles.pos}>
              {`${subHeader > 0 ? '+' : ''}${subHeader}%`}
            </p>
            <span>YoY</span>
          </>
        ) : undefined}
      </div>
    </div>
  );

  render() {
    const { cards, isLoading } = this.props;
    return (
      <div className={styles.watchListCarouselWrapper}>
        <div
          style={{ width: this.returnCarouselLength(cards) }}
          className={styles.watchListCarouselContainer}
        >
          {cards.map(
            ({
              company,
              totalNumber,
              totalNumberYoY,
              totalPercentage,
              totalPercentageYoY,
            }) => (
              <div key={company} className={styles.cardContainer}>
                {/* CARD HEADER */}
                <div className={styles.cardHeader}>
                  <p>{capitalize(company)}</p>
                </div>
                <div className={styles.detailsContainer}>
                  {/* TOTAL NUMBER */}
                  {this.renderDetails(totalNumber, totalNumberYoY)}
                  {/* TOTAL PERCENTAGES */}
                  {this.renderDetails(totalPercentage, totalPercentageYoY)}
                </div>
                {isLoading ? (
                  <div className={styles.loaderWrapper}>
                    <Loader />
                  </div>
                ) : null}
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

WatchListCarousel.propTypes = {
  cards: PropTypes.any.isRequired, // eslint-disable-line
  isLoading: PropTypes.bool.isRequired
};

export default WatchListCarousel;
